import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { delay } from 'rxjs/operators';

import {
  BusinessUnitListQuery,
  BusinessUnitDirectoryRepository,
} from '@app/domain/ports/tpv/business-unit.repository';
import { TpvBusinessUnit } from '@app/domain/models/tpv/business-unit.model';
import { TpvPage } from '@app/domain/models/tpv/tpv-page.model';

/** Mock del directorio de unidades de negocio para pruebas sin backend (tpvUseMocks). */
@Injectable()
export class BusinessUnitMockDataSource extends BusinessUnitDirectoryRepository {
  private readonly units: TpvBusinessUnit[] = [
    { idUnit: 'mock-uuid-unit-1', idCompany: 'mock-company-1', name: 'Unidad Demo 1', companyName: 'Demo 1 SA de CV', status: 'active', entity: 'MX', totalMerchants: 12 },
    { idUnit: 'mock-uuid-unit-2', idCompany: 'mock-company-1', name: 'Unidad Demo 2', companyName: 'Demo 1 SA de CV', status: 'inactive', entity: 'MX', totalMerchants: 3 },
    { idUnit: 'mock-uuid-unit-3', idCompany: 'mock-company-2', name: 'Unidad Demo 3', companyName: 'Demo 2 SA de CV', status: 'active', entity: 'MX', totalMerchants: 7 },
  ];

  override getBusinessUnits(
    query: BusinessUnitListQuery = {},
  ): Observable<TpvPage<TpvBusinessUnit>> {
    // `search` es el filtro nuevo (contrato 2026-09-29): OR entre nombre, razón
    // social, empresa y RFC. `merchantName` sigue soportado como back-compat.
    const term = (query.search ?? query.merchantName ?? '').toLowerCase().trim();
    const isSearch = !!query.search;
    const idCompany = query.idCompany?.trim();
    let filtered = this.units;
    if (idCompany) {
      // Paridad con el remote: scope por empresa cuando el caller lo pasa.
      filtered = filtered.filter((u) => u.idCompany === idCompany);
    }
    if (term) {
      filtered = filtered.filter((u) => {
        const anyU = u as unknown as { rfc?: string; legalName?: string };
        if (isSearch) {
          return (
            u.name.toLowerCase().includes(term) ||
            (anyU.legalName ?? '').toLowerCase().includes(term) ||
            (u.companyName ?? '').toLowerCase().includes(term) ||
            (anyU.rfc ?? '').toLowerCase().includes(term)
          );
        }
        return (
          u.name.toLowerCase().includes(term) ||
          (u.companyName ?? '').toLowerCase().includes(term)
        );
      });
    }
    return of({
      data: filtered,
      total: filtered.length,
      page: query.page ?? 1,
      limit: query.limit ?? 10,
    }).pipe(delay(300));
  }
}
